import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import SecureLS from 'secure-ls';
// shared
import authUser from '@/app/stores/modules/_shared/auth-user';
import sideBar from '@/app/stores/modules/_shared/sidebar';
import lmdcUser from '@/app/stores/modules/_shared/lmdc-user';
import notification from '@/app/stores/modules/_shared/notification';
import currentPage from './modules/_shared/currentPage.js';

// Auth-Registration
import registrationPetDetails from './modules/components/auth-registration/auth-registration.js';

// Social club
import socialClubStore from '@/app/stores/modules/components/social-club/social-club';
import socialGroupStore from '@/app/stores/modules/components/social-club/social-club-group';

// Shopping
import cartStore from '@/app/stores/modules/components/shopping/cart';
import publicCartStore from '@/app/stores/modules/components/shopping/public-cart';

const ls = new SecureLS({isCompression: false});
Vue.use(Vuex)
export default new Vuex.Store({
    plugins: [createPersistedState({
        paths: [
            'lmdcUser',
            'cartStore',
            'socialGroupStore',
            'publicCartStore'
        ],
        storage: {
            getItem: (key) => ls.get(key),
            setItem: (key, value) => ls.set(key, value),
            removeItem: (key) => ls.remove(key)
        }
    })],
    modules: {
        // shared
        authUser,
		lmdcUser,
		sideBar,
		notification,
        currentPage,
        // registration
        registrationPetDetails,
        // social club
        socialClubStore,
        socialGroupStore,
        // shopping
        cartStore,
        publicCartStore
    }
})
